import React, { useEffect } from "react";
import gsap from "gsap";

const Loader = () => {
  useEffect(() => {
    // GSAP animation for scaling and rotating effects
    gsap.to(".spinner", {
      rotation: 360,
      repeat: -1,
      duration: 2,
      ease: "power1.inOut",
    });

    gsap.to(".dot", {
      scale: 1.5,
      repeat: -1,
      yoyo: true,
      duration: 0.8,
      ease: "power1.inOut",
      stagger: 0.2,
    });
  }, []);

  return (
    <div className="fixed w-full h-full bg-[#244434] bg-opacity-95 z-[9999999] inset-0 flex flex-col items-center justify-center">
      {/* Rotating Spinner */}
      <div className="spinner relative w-24 h-24 border-4 border-[#c7882b] border-t-transparent border-solid rounded-full mb-8"></div>

      {/* Pulsating Dots */}
      <div className="flex gap-4">
        <div className="dot w-4 h-4 bg-[#c7882b] rounded-full"></div>
        <div className="dot w-4 h-4 bg-[#c7882b] rounded-full"></div>
        <div className="dot w-4 h-4 bg-[#c7882b] rounded-full"></div>
      </div>

      {/* Loader Text */}
      <p className="text-[#c7882b] text-lg font-bold mt-6">
        Loading, please wait...
      </p>
    </div>
  );
};

export default Loader;
